import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import ProjektiAdd from "./ProjektiAdd";
import ProjektiEdit from "./ProjektiEdit";
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import cloneDeep from 'lodash.clonedeep';
import SortColButton from "../SortColButton";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import { authFetch, authPost } from "../../authProvider";
import { ExportDataButtons } from '../ExportDataButtons';
import { LanguageContext } from '../LanguageContext';
import moment from 'moment';

/* Näkymäkohtaiset muuttujat ja vakiot */
const API_PREFIX = 'api/Inventory/Projekti';
const API_ASIAKKAAT_PREFIX = 'api/Asiakas';
const API_DATAEXPORT_PREFIX = 'api/export/table';

const default_columns = [
    {
        label: "RiviAvain",
        name: "riviAvain",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Asiakas",
        name: "asiakasAvain",
        options: {
            filter: true,
            display: true,
            customBodyRender: function (value, tableMeta, updateValue) {
                return asiakkaat[value];
            },
            lookuplist: 'asiakkaat'
        }
    },
    {
        label: "Nimi",
        name: "nimi",
        options: {
            filter: false,
            display: true
        }
    },
    {
        label: "Omistaja",
        name: "omistaja",
        options: {
            filter: true,
            display: true
        }
    },
    {
        label: "Tarkoitus",
        name: "tarkoitus",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Tavoitteet",
        name: "tavoitteet",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Tyyppi",
        name: "tyyppi",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Sijainti",
        name: "sijainti",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "OlosuhteetEnnen",
        name: "olosuhteetEnnen",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "ParannustenSaavuttaminen",
        name: "parannustenSaavuttaminen",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "ArviotuParannustenMaara",
        name: "arviotuParannustenMaara",
        options: {
            filter: false,
            display: true
        }
    },
    {
        label: "Riskit",
        name: "riskit",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "RoolitJaVastuut",
        name: "roolitJaVastuut",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Ohjelmat",
        name: "ohjelmat",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Vaikutusarvio",
        name: "vaikutusarvio",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Lopputulemat",
        name: "lopputulemat",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "Alkupvm",
        name: "alkupvm",
        options: {
            filter: false,
            display: true
        }
    },
    {
        label: "Loppupvm",
        name: "loppupvm",
        options: {
            filter: false,
            display: true
        }
    },
    {
        label: "Luotu",
        name: "created",
        options: {
            filter: false,
            display: false,
            customBodyRender: function (value, tableMeta, updateValue) {
                var date = moment(value).format("D.M.YYYY, HH:mm");
                return moment(value).isValid() ? date : "";
            },
        }
    },
    {
        label: "Muokattu",
        name: "updated",
        options: {
            filter: false,
            display: false,
            customBodyRender: function (value, tableMeta, updateValue) {
                var date = moment(value).format("D.M.YYYY, HH:mm");
                return moment(value).isValid() ? date : "";
            },
        }
    },
    {
        label: "Muokkaaja",
        name: "username",
        options: {
            filter: false,
            display: false
        }
    }
];

/* Perusmuuttujat ja vakiot */
const PROFIILI_GET = 'api/Profiili/Read';
const PROFIILI_PUT = 'api/Profiili/Update';

var rowId;
var selectedRows = [];
var items = [];
var asiakkaat = {};

/* Luokka */
export class Projekti extends Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        // State alustukset
        this.state = {
            lookupLists: {
                asiakkaat: asiakkaat,
            },
            rowsSelected: [],
            loading: true,
            rowNum: 25,
            errorShow: false,
            errorTitle: '',
            errorBody: '',
            sortOrder: { name: 'riviAvain', direction: 'asc' },
            route: "",
            fileData: "",
        };

        //Bindit
        this.swapCols = this.swapCols.bind(this);
        this.addNewItem = this.addNewItem.bind(this);

        //asiakkaat
        authFetch(this.props.pca, API_ASIAKKAAT_PREFIX + '/Read')
            .then(response => response.json())
            .then(data => {
                data.forEach((d, i) => {
                    asiakkaat[d.riviAvain] = (d.asiakasNimi || 'ei tietoja');
                });
                //Items
                authFetch(this.props.pca, API_PREFIX + '/Read')
                    .then(response => response.json())
                    .then(data => {
                        items = data

                        //Profiili
                        authFetch(this.props.pca, PROFIILI_GET)
                            .then(response => response.json())
                            .then(data => {
                                var cols = (((JSON.parse((data || [])[0].uI_Settings) || {}).columns || {}).projekti || []); // TODO: muuta avain
                                if (cols.length > 0) cols = JSON.parse(cols);
                                else cols = null;

                                // hidden cols
                                var hidden_cols = (((JSON.parse((data || [])[0].uI_Settings) || {}).hiddencolumns || {}).projekti || []); // TODO: muuta avain
                                if (hidden_cols.length > 0) hidden_cols = JSON.parse(hidden_cols);
                                else hidden_cols = null;

                                // rowNum
                                var rowNum = (((JSON.parse((data || [])[0].uI_Settings) || {}).rownum || {}).projekti || []); // TODO: muuta avain
                                if (rowNum.length > 0) rowNum = JSON.parse(rowNum);
                                else rowNum = 25;

                                var columns = get_ordered_columns(cols, hidden_cols);

                                this.setState({
                                    lookupLists: {
                                        asiakkaat: asiakkaat
                                    },
                                    columns: columns,
                                    data: items,
                                    loading: false,
                                    rowNum: rowNum
                                });
                            });
                    });
            });
    }

    swapCols = (index) => {
        if (index > 1) {
            var cols = cloneDeep(this.state.columns);
            var d = this.state.data;
            [cols[index - 1], cols[index]] = [cols[index], cols[index - 1]];
            this.setState({ columns: cols });
            var setting = { "key": "columns.projekti", "value": JSON.stringify(cols.map(function (d) { return d.name; })).split('"').join('""') }; // TODO: muuta avain
            authPost(this.props.pca, PROFIILI_PUT, {
                body: JSON.stringify(setting)
            });
        }
    };

    changeRownum = (num) => {
        this.setState({ rowNum: num })

        var setting = { "key": "rownum.projekti", "value": JSON.stringify(num).split('"').join('""') }; // TODO: muuta avain
        authPost(this.props.pca, PROFIILI_PUT, {
            body: JSON.stringify(setting)
        })
    };

    hiddenCols = (changedColumn, action) => {
        var cols = cloneDeep(this.state.columns);
        var hidden = [];

        for (var i = 0; i < cols.length; i++) {
            if (!(cols[i].options))
                cols[i].options = {};

            if (cols[i].name == changedColumn)
                cols[i].options.display = (action === "add" ? true : false)

            if (cols[i].options.display == false) {
                hidden.push(cols[i].name);
            }
        }

        if (action === "add") {
            hidden.splice(hidden.indexOf(changedColumn), 1);
        }
        else if (action === "remove") {
            hidden.push(changedColumn);
        }

        this.setState({ columns: cols });
        var setting = { "key": "hiddencolumns.projekti", "value": (hidden.length > 0 ? JSON.stringify(hidden).split('"').join('""') : "[]") }; // TODO: muuta avain
        authPost(this.props.pca, PROFIILI_PUT, {
            body: JSON.stringify(setting)
        })
    };

    handleError = (error) => {
        const { onError } = this.props;

        var title = '', body = ''
        if (error === 4) {
            title = this.context.dictionary.ErrorDialog.Error4.title;
            body = this.context.dictionary.ErrorDialog.Error4.body;
        } else if (error === 5) {
            title = this.context.dictionary.ErrorDialog.Error5.title;
            body = this.context.dictionary.ErrorDialog.Error5.body;
        } else {
            title = this.context.dictionary.ErrorDialog.Error.title;
            body = this.context.dictionary.ErrorDialog.Error.body;
        }

        onError(title, body);
    }

    handleErrorClose = () => this.setState({ errorShow: false });

    addNewItem = (newrow) => {
        // ADD
        var data = cloneDeep(this.state.data);
        data = data.concat(newrow);
        authPost(this.props.pca, API_PREFIX + '/Create', {
            body: JSON.stringify(newrow)
        })
            .then(response => response.json())
            .then(data => {
                if ((data || {}).error) {
                    this.handleError(data.error);
                } else {
                    authFetch(this.props.pca, API_PREFIX + '/Read')
                        .then(response => response.json())
                        .then(data => {
                            this.setState({ data: data, rowsSelected: [] })
                            this.handleMessage(this.context.dictionary.Message.Add)
                        });
                }
            });
    }

    editItem = (newrow) => {
        // EDIT
        authPost(this.props.pca, API_PREFIX + '/Update', {
            body: JSON.stringify(newrow)
        })
            .then(response => response.json())
            .then(data => {
                if ((data || {}).error) {
                    this.handleError(data.error);
                } else {
                    authFetch(this.props.pca, API_PREFIX + '/Read')
                        .then(response => response.json())
                        .then(data => {
                            this.setState({ data: data, rowsSelected: [] })
                            this.handleMessage(this.context.dictionary.Message.Edit)
                        });
                }
            });
    }

    handleMessage = (msg) => {
        const { onMessage } = this.props;
        onMessage(msg);
    }

    handleSortChange = (changedColumn, direction) => {
        this.setState({
            sortOrder: { name: changedColumn, direction },
        });
    };

    render() {
        const { dictionary } = this.context;

        var cols = cloneDeep(this.state.columns);
        if ((cols || []).length > 0) {
            for (var i = 0; i < default_columns.length; i++) {
                for (var j = 0; j < cols.length; j++) {
                    if (cols[j].label == default_columns[i].label) {
                        cols[j].label = dictionary.Inventory.Projekti.Columns[i] //TODO: Muuta avain
                    }
                }
            }
        }

        var options = {
            textLabels: dictionary.MuiDataTable.textLabels,
            selectableRowsHeader: true,
            selectableRowsOnClick: true,
            selectableRows: "multiple",
            filterType: 'multiselect',
            responsive: "vertical",
            tableBodyHeight: "calc(100vh - 180px)",
            rowsPerPageOptions: [5, 10, 25, 50, 100],
            rowsPerPage: this.state.rowNum,
            jumpToPage: true,
            rowsSelected: this.state.rowsSelected,
            sortOrder: this.state.sortOrder,
            onColumnSortChange: this.handleSortChange,
            onViewColumnsChange: (changedColumn, action) => {
                this.hiddenCols(changedColumn, action);
            },
            onRowSelectionChange: (currentRowsSelected, allRows, rowsSelected) => {
                const { data } = this.state;
                rowId = null;
                if (rowsSelected.length > 0) {
                    rowId = data[rowsSelected[0]].riviAvain; //TODO: Muuta avain
                }
                this.setState({ rowsSelected: rowsSelected });
            },
            onChangeRowsPerPage: (num) => {
                this.changeRownum(num);
            },
            // Huomioi samat arvot ja sen jölkeen lajitellaan ensimmäisen sarakkeen (id) mukaan
            customSort: (data, colIndex, order) => {
                const { columns, lookupLists } = this.state;

                return data.sort((a, b) => {
                    if (a.data[colIndex] == b.data[colIndex]) {
                        // samanarvoisissa riveissä otetaan riviavainjärjestys
                        return ((a.data[0] || -9e6) < (b.data[0] || -9e6) ? -1 : 1) * (order === 'desc' ? 1 : -1);
                    } else if (columns[colIndex].options.lookuplist) {
                        // lookuplist lajittelu
                        const list = lookupLists[columns[colIndex].options.lookuplist];
                        var aa = (list[a.data[colIndex]] || ''), bb = (list[b.data[colIndex]] || '');

                        return ((parseInt(!/[^0-9]/i.test(aa) ? aa : 'x') || aa.toString()) < (parseInt(!/[^0-9]/i.test(bb) ? bb : 'x') || bb.toString()) ? -1 : 1) * (order === 'desc' ? 1 : -1);
                    } else {
                        // normaali lajittelu
                        return ((a.data[colIndex] || -9e6) < (b.data[colIndex] || -9e6) ? -1 : 1) * (order === 'desc' ? 1 : -1);
                    }
                });
            },
            customToolbarSelect: (selRows, displayData, setSelectedRows) => {
                const { data } = this.state;

                if ((selRows.data || []).length > 0) {
                    selectedRows = selRows.data.map(d => (d.dataIndex));
                    rowId = data[selectedRows[0]].riviAvain; //TODO: Muuta avain
                }

                var handleDelete = () => {
                    var data = cloneDeep(this.state.data);

                    if (window.confirm(dictionary.DeleteConfirmation + selectedRows.map(d => data[d].riviAvain).join(", "))) {
                        var requests = []
                        for (var i = 0; i < selectedRows.length; i++) {
                            requests.push(
                                authPost(this.props.pca, API_PREFIX + '/Delete/' + data[selectedRows[i]].riviAvain, { method: 'delete' }) //TODO: Muuta avain
                            );
                        }
                        Promise.all(requests)
                            .then(() => {
                                setSelectedRows([]);
                                authFetch(this.props.pca, API_PREFIX + '/Read')
                                    .then(response => response.json())
                                    .then(data => {
                                        this.handleMessage(`(${selectedRows.length}) ${dictionary.Message.Delete}`)
                                        this.setState({ data: data, rowsSelected: [] });
                                    });
                            });
                    }
                }

                var handleCopy = () => {
                    const { data } = this.state;
                    if (window.confirm(dictionary.CopyConfirmation + selectedRows.map(d => data[d].riviAvain).join(", "))) {
                        var requests = []
                        for (var i = 0; i < selectedRows.length; i++) {
                            const row = data[selectedRows[i]];
                            var newrow = {
                                RiviAvain: 1, //dummy-arvo
                                AsiakasAvain: row.asiakasAvain,
                                Nimi: row.nimi + "-kopio",
                                Omistaja: row.omistaja,
                                Tarkoitus: row.tarkoitus,
                                Tavoitteet: row.tavoitteet,
                                Tyyppi: row.tyyppi,
                                Sijainti: row.sijainti,
                                OlosuhteetEnnen: row.olosuhteetEnnen,
                                ParannustenSaavuttaminen: row.parannustenSaavuttaminen,
                                ArviotuParannustenMaara: row.arviotuParannustenMaara,
                                Riskit: row.riskit,
                                RoolitJaVastuut: row.roolitJaVastuut,
                                Ohjelmat: row.ohjelmat,
                                Vaikutusarvio: row.vaikutusarvio,
                                Lopputulemat: row.lopputulemat,
                                Alkupvm: row.alkupvm,
                                Loppupvm: row.loppupvm,
                                Created: row.created,
                                Updated: row.updated,
                                Username: row.username,
                            };
                            requests.push(
                                authPost(this.props.pca, API_PREFIX + '/Create', { body: JSON.stringify(newrow) })
                            );
                        }
                        Promise.all(requests)
                            .then(() => {
                                authFetch(this.props.pca, API_PREFIX + '/Read')
                                    .then(response => response.json())
                                    .then(data => {
                                        this.handleMessage(`(${selectedRows.length}) ${dictionary.Message.Copy}`)
                                        this.setState({ data: data, rowsSelected: [] });
                                    });
                            });
                    }
                }

                //Define route
                var handlePDF = () => {
                    this.setState({
                        route: '/PDF',
                        loading: true
                    }, () => handleExportData());
                }

                var handleWord = () => {
                    this.setState({
                        route: '/Word',
                        loading: true
                    }, () => handleExportData());
                }

                var handleExcel = () => {
                    this.setState({
                        route: '/Excel',
                        loading: true
                    }, () => handleExportData());
                }

                //Export Data API connection
                var handleExportData = () => {

                    selectedRows = selRows.data.map(d => (d.dataIndex));
                    const row = data[selectedRows[0]];

                    const rows = Object.values({ row });
                    const keys = Object.keys(row);

                    const columns = keys.map(column => {
                        return {
                            key: column,
                            title: column,
                            format: "",
                            align: "right"
                        }
                    });

                    authPost(this.props.pca, API_DATAEXPORT_PREFIX + this.state.route, {
                        body: JSON.stringify({
                            fileName: "",
                            culture: "",
                            columns: columns,
                            rows: rows
                        })
                    })
                        .then(response => response.text())
                        .then(data => {
                            if ((data || {}).error) {
                                this.handleError(data.error);
                            }
                            else {
                                this.setState({
                                    fileData: data
                                }, () => handleShowData());
                            }
                        })
                }

                var handleShowData = () => {
                    var JSONdata = JSON.parse(this.state.fileData);

                    var newFileData = JSONdata.path.toString();
                    this.setState({
                        loading: false,
                        fileData: newFileData
                    }, () => this.handleMessage(dictionary.ExportData.DownloadSuccessSnackbar + this.state.fileData))
                }

                return (
                    <div className={"custom-toolbar-select"}>
                        {(selectedRows.length < 2) ? (
                            <React.Fragment>
                                <ExportDataButtons
                                    handlePDF={handlePDF}
                                    handleWord={handleWord}
                                    handleExcel={handleExcel}
                                ></ExportDataButtons>
                                <ProjektiEdit onEditRow={this.editItem} lookupLists={this.state.lookupLists} Daatta={this.state.data} rowId={rowId} />
                                <Tooltip title={dictionary.Toolbar.Copy}>
                                    <IconButton onClick={handleCopy}>
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={dictionary.Toolbar.Delete}>
                                    <IconButton onClick={handleDelete}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <Tooltip title={dictionary.Toolbar.Copy}>
                                    <IconButton onClick={handleCopy}>
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={dictionary.Toolbar.Delete}>
                                    <IconButton onClick={handleDelete}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </React.Fragment>
                        )}
                    </div>
                );
            },
            customToolbar: () => {
                return (
                    <React.Fragment>
                        <ProjektiAdd onAddNewRow={this.addNewItem} lookupLists={this.state.lookupLists} />
                        <SortColButton columns={this.state.columns} onOrderChange={this.swapCols} />
                    </React.Fragment>
                );
            }

        };

        //dictionary.<komponentin nimi>.Title
        return (
            <div style={{ padding: 10 }}>
                <div>
                    {(this.state.loading) ? (
                        <CircularProgress />
                    ) : (
                        <MUIDataTable
                            title={dictionary.Inventory.Projekti.Title}
                            data={this.state.data}
                            columns={cols}
                            options={options}
                        />
                    )
                    }
                </div>
            </div>
        );
    }
}

function get_ordered_columns(list, hidden) {
    var columns = [];

    if (!Array.isArray(list)) {
        list = default_columns.map((c) => (c.name));
    }

    list.forEach(function (el) {
        columns.push((default_columns.filter(function (d) { return d.name == el; }) || [])[0]);
        if (hidden != null) {
            if (!(columns[columns.length - 1].options))
                columns[columns.length - 1].options = {};
            if (hidden.indexOf(columns[columns.length - 1].name) > -1) {
                columns[columns.length - 1].options.display = false;
            } else {
                columns[columns.length - 1].options.display = true;
            }
        }
    });

    return columns;
}